module.exports = __webpack_public_path__ + "static/media/logo-snip.72f6638f.png";